import { render, staticRenderFns } from "./GatewayDetailsVol.vue?vue&type=template&id=706b9c00"
import script from "./GatewayDetailsVol.vue?vue&type=script&lang=js"
export * from "./GatewayDetailsVol.vue?vue&type=script&lang=js"
import style0 from "./GatewayDetailsVol.vue?vue&type=style&index=0&id=706b9c00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports